module.exports = __webpack_public_path__ + "fonts/StagSans-Semibold.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Semibold.otf
// module id = 1092
// module chunks = 0